import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ngisense/P4D/Parts4Drive/packages/eve-chat/app/[country]/products/[slug]/ProductActionsClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ngisense/P4D/Parts4Drive/packages/eve-chat/app/[country]/products/[slug]/ProductGalleryClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ngisense/P4D/Parts4Drive/packages/eve-chat/components/CategoryIcon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ngisense/P4D/Parts4Drive/packages/eve-chat/components/ProductShareBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ngisense/P4D/Parts4Drive/packages/eve-chat/components/VehicleBrandLogo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ngisense/P4D/Parts4Drive/packages/eve-chat/node_modules/next/dist/client/app-dir/link.js");
